/**
 * This plugin is used in conjunction with our apache `cookie-monster` workaround.
 *
 * Its purpose is to delete all client-side cookies that were deleted server-side,
 * which is necessary since set-cookie headers were eaten by our cookie-monster.
 *
 * @see https://it.fressnapf.de/browse/WEB-3330 (related ticket)
 * @see tools/docker/storefront/apache/nodejs.conf (apache cookie monster)
 */
export default defineNuxtPlugin({
  name: 'delete-cookies',
  dependsOn: ['pinia', 'i18n:plugin'],
  async setup(nuxtApp) {
    nuxtApp.runWithContext(() => applyDeleteCookies());

    // Browser needs a moment to fully update `document.cookie` value in `applyDeleteCookies` above
    if (import.meta.client) {
      await nextTick();
    }
  },
});
